import type { Paginator as PrimePaginator } from "primereact/paginator";
import { forwardRef } from "react";

import type { PaginatorProps } from "./types-paginator";
import { usePaginator } from "./use-paginator";
import { PaginatorView } from "./view-paginator";

/**
 * `Paginator` do Prime com o template, o relatório, as opções de linhas por página e os rótulos em pt-BR do Hub como
 * padrão (a tela sobrescreve por prop). O `ref` é a instância do Prime (`getElement`).
 */
export const Paginator = forwardRef<PrimePaginator, PaginatorProps>(function Paginator(props, ref) {
  const viewModel = usePaginator(props, ref);

  return <PaginatorView {...viewModel} />;
});
Paginator.displayName = "Paginator";
